import { render, staticRenderFns } from "./VueBootstrapTypeaheadListItem.vue?vue&type=template&id=4bb3f417&"
import script from "./VueBootstrapTypeaheadListItem.vue?vue&type=script&lang=js&"
export * from "./VueBootstrapTypeaheadListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports